import * as THREE from 'three'
import { DEG2RAD } from 'three/src/math/MathUtils.js'
import { buildNodeFaces, buildNodeBasic } from './buildNode'

const m1 = new THREE.Matrix4()
const m2 = new THREE.Matrix4()
const v1 = new THREE.Vector3()
const v2 = new THREE.Vector3()
const q1 = new THREE.Quaternion()
const e1 = new THREE.Euler()

export function buildNodes(node, props) {
  const out = {
    faces: [],
    collider: {
      position: [],
      index: [],
    },
    hitbox: {
      position: [],
      index: [],
      // normal: [],
    },
  }

  // start recursion with identity matrix
  const identityMatrix = m1.identity()
  // recursively process nodes with accumulated transform
  processNode(node, props, identityMatrix, out)
  return out
}

function processNode(node, props, parentMatrix, out) {
  if (!meetsConditions(node, props)) return

  // build local transform matrix
  const localMatrix = m2
  const position = v1.fromArray(node.position)
  const rotation = e1.set(0, 0, 0)
  if (node.rotation) e1.set(node.rotation[0] * DEG2RAD, node.rotation[1] * DEG2RAD, node.rotation[2] * DEG2RAD)
  const scale = v2.set(1, 1, 1)
  if (node.scale) v2.fromArray(node.scale)
  localMatrix.compose(position, q1.setFromEuler(rotation), scale)

  // accumulate with parent transform
  const worldMatrix = new THREE.Matrix4().multiplyMatrices(parentMatrix, localMatrix)

  // build it
  if (node.type === 'box') {
    buildNodeFaces(worldMatrix, node, out.faces)
  } else if (node.type === 'collider' && out.collider) {
    buildNodeBasic(worldMatrix, node, out.collider)
  } else if (node.type === 'hitbox' && out.hitbox) {
    buildNodeBasic(worldMatrix, node, out.hitbox)
  }

  // recursively process children
  // if (node.children) {
  for (const child of node.children) {
    processNode(child, props, worldMatrix, out)
  }
  // }
}

function meetsConditions(node, props) {
  for (const condition of node.conditions) {
    if (condition.op === 'eq' && props[condition.prop] !== condition.value) return false
    if (condition.op === 'ne' && props[condition.prop] === condition.value) return false
  }
  return true
}
